import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["relevanceSelect", "contentcategorySelect"]

  connect() {
    // Optional: initiales Laden
    this.updateContentcategories()
  }

  updateContentcategories() {
    const relevance = this.relevanceSelectTarget.value

    fetch(`/contentcategories/filter_by_relevance?relevance=${relevance}`)
      .then(response => response.json())
      .then(data => {
        this.contentcategorySelectTarget.innerHTML = ""

        const prompt = document.createElement("option")
        prompt.textContent = "Bitte wählen"
        prompt.value = ""
        this.contentcategorySelectTarget.appendChild(prompt)

        data.forEach((category) => {
          const option = document.createElement("option")
          option.value = category.id
          option.textContent = category.name
          this.contentcategorySelectTarget.appendChild(option)
        })
      })
  }
}
